export enum InsightsResultsView {
    INSIGHTS = 'insights',
    DOCUMENTS = 'documents',
}

export interface InsightsProviderInterface {
    tableView: InsightsResultsView;
    handleTableView: (view: InsightsResultsView) => void;
}
